// extracted by mini-css-extract-plugin
export var downArrow = "_ea-0";
export var infoTooltipIcon = "_ea-3";
export var label = "_ea-1";
export var optionCard = "_ea-4";
export var upArrow = "_ea-2";